import configuration from 'globalConfiguration';
import composer from 'helper/htmlComposer';

function OverlayHelper() {
	this.configuration = configuration.OverlayHelper;
	this.isFullscreenOverlay = false;
	this.loader = composer.generateDiv(this.configuration.overlayClassName);
	this.imgRotator = composer.generateImage(this.configuration.overlayImageSource, undefined, this.configuration.overlayImageClassName)
		.css(this.configuration.overlayImageCss);
	this.rotator = composer.generateDiv(this.configuration.overlayImageClassName)
		.css(this.configuration.overlayImageCss);
	if (this.configuration.overlayText !== undefined) {
		var overlayText = composer.generateElement('p', 'overlayText');
		overlayText.text(this.configuration.overlayText);
		this.rotator.append(overlayText);
	}
	this.rotator.append(this.imgRotator);
	this.loader.append(this.rotator);
	this.dom = this.loader;
	this.appendArea = undefined;
}

OverlayHelper.prototype = {

	createInstance: function () {
		return new OverlayHelper();
	},

	setFullscreenOverlay: function (value) {
		this.isFullscreenOverlay = value;
	},

	setAppendArea: function (element) {
		this.appendArea = element;
	},

	displayOverlay: function () {
		if (this.isFullscreenOverlay) {
			this.loader.removeClass('overlayHelper');
		} else {
			this.loader.addClass('overlayHelper');
		}
		this.appendArea.append(this.dom);
	},

	removeOverlay: function () {
		this.dom.remove();
	},
};

export default new OverlayHelper();
